import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ContatoAnexoService {

  constructor(private http: HttpClient) {}

  consultarContatoAnexosComPaginacao(idContato, descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, origem) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('origem', origem)
      .set('idContato', idContato);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/ContatoAnexo/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdContatoAnexo(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ContatoAnexo/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultarDadosLog(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ContatoAnexo/BuscarDadosLog',
      { params: new HttpParams().set('id', id) });
  }

  salvar(contatoAnexo) {
    return this.http.post(globals.apiUrl + '/api/ContatoAnexo/Salvar', contatoAnexo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ContatoAnexo/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
